import React from 'react';
import { STATUS_LABELS } from './gridModel';

// Day title with prev/next navigation and the Move / Delete / Save actions
export default function EditorHeader({ onBack, navigateDay, weekday, dd, mm, yyyy, status, moveCrossword, deletePuzzle, save, unsaved }) {
  return (
    <header className="editor-header">
      <button onClick={onBack} className="editor-back" type="button">
        <span className="material-symbols-outlined" aria-hidden="true">calendar_month</span>
        Calendar
      </button>

      <div className="editor-day">
        <button type="button" className="day-step" onClick={() => navigateDay(-1)}
          title="Previous day (Alt+←)" aria-label="Previous day">
          <span className="material-symbols-outlined" aria-hidden="true">chevron_left</span>
        </button>
        <div className="day-title">
          <h2>{weekday} {dd}.{mm}.{yyyy}</h2>
          <span className={`status-chip status-${status}`}>{STATUS_LABELS[status]}</span>
        </div>
        <button type="button" className="day-step" onClick={() => navigateDay(1)}
          title="Next day (Alt+→)" aria-label="Next day">
          <span className="material-symbols-outlined" aria-hidden="true">chevron_right</span>
        </button>
      </div>

      <div className="editor-actions">
        <button onClick={moveCrossword} className="btn-quiet" type="button">Move</button>
        <button onClick={deletePuzzle} className="btn-quiet btn-quiet-danger" type="button">Delete</button>
        <button onClick={save} className={`btn-save ${unsaved ? 'unsaved' : ''}`} type="button" title="Save (Ctrl+S)">
          {unsaved ? 'Save changes' : 'Saved'}
        </button>
      </div>
    </header>
  );
}
